import { Component, OnDestroy, OnInit } from "@angular/core";
import { Platform } from "@ionic/angular";
import { Router } from "@angular/router";

import { BaseHelper } from "./baseHelper";
import { Pages } from "./interfaces/pages";
import { GlobalProvider } from "src/services/global";
import { UserAPIService } from "src/services/user_api.service";
import { AuthService } from "src/services/auth.service";
import { MenuHelper } from "./menuHelper";
import { PublicAPI } from "src/services/public_api.service";
import { Capacitor } from "@capacitor/core";
import { currentVersion } from "src/environments/environment";
import { AlertController } from "@ionic/angular";
import { FcmService } from "src/services/fcm.service";
import { BarcodeScanner } from "@capacitor-community/barcode-scanner";

// import { NotificationSocket } from 'src/services/notification_socket.service';

/// try
import { fromEvent, merge, of, Subscription } from "rxjs";
import { map } from "rxjs/operators";

import { AfterViewInit, ViewChild } from '@angular/core';
import{ LoaderComponent } from './components/loader/loader.component';
import { LoaderService } from './components/loader/loader.service';

@Component({
    selector: "app-root",
    templateUrl: "app.component.html",
    styleUrls: [
        "app.component.scss",
        "./style/side-menu.scss",
        "./style/side-menu.responsive.scss",
    ],
    standalone: false
})
export class AppComponent
  implements OnInit, OnDestroy{
  
  textDir;

  ////try
  networkStatus: boolean = false;
  networkStatus$: Subscription = Subscription.EMPTY;

  // public generalPages: Array<Pages>;
  constructor(
    private platform: Platform,
    public b: BaseHelper,
    private userAPI: UserAPIService,
    private authAPI: AuthService,
    private pubApi: PublicAPI,
    public g: GlobalProvider,
    public m: MenuHelper,
    private router: Router,
    private alertCtrl: AlertController,
    private fcm: FcmService,
    private loaderService: LoaderService
  ) {
    this.initializeApp();
  }
  
 

  ///// try
  ngOnInit(): void {
    // this.checkNetworkStatus();
  }

  ngOnDestroy(): void {
    this.networkStatus$.unsubscribe();
  }

  checkNetworkStatus() {
    this.networkStatus = navigator.onLine;
    this.networkStatus$ = merge(
      of(null),
      fromEvent(window, "online"),
      fromEvent(window, "offline")
    )
      .pipe(map(() => navigator.onLine))
      .subscribe(async (status) => {
        // console.log("internet connection status", status);
        // this.b.toast(`Internet connection status: ${status}`, 10000, "warning");
        this.networkStatus = status;

        if (!this.networkStatus) {
          this.b.toast(
            `Internet connection not found. Please ensure that you are connected to an internet, and try again.`,
            20000,
            "danger"
          );
        } else {
          // this.b.toast(`Internet connection found.`, 20000, "success");
        }

        const tokenObj = await this.b.getJws();
        if (tokenObj) {
          this.g.token = tokenObj;
        } else {
          this.g.token = null;
        }
        if (this.g.token) {
          // this.b.toast(
          //   `G-Token found on internet connection ${this.networkStatus}.`,
          //   20000,
          //   "success"
          // );
          // this.g.token = tokenObj;
          this.g.gHasToken = true;
        } else {
          // this.b.toast(
          //   `G-Token not found on internet connection ${this.networkStatus}.`,
          //   20000,
          //   "danger"
          // );
        }
      });
  }
  ///// end of try

  initializeApp() {
    this.platform.ready().then(async () => {
      this.checkNetworkStatus();
      this.b.menuOpen();
      this.checkVersion();

      const urlParams = new URLSearchParams(window.location.search);
      const sso = urlParams.get("sso");
      const resetToken = urlParams.get("resetToken");
      if (resetToken) {
      } else {
        if (sso) {
        } else {
          const tokenObj = await this.b.getJws();
          console.log("tokenObj?", tokenObj)
          // console.log(`this.router.url?`, this.router.url);

          // const publicGi = await (await this.pubApi.globalSetting()).toPromise().catch((err) => {
          //   return Promise.resolve(null);
          // });
          // if (publicGi) {
          //   const { detail } = publicGi;
          //   console.log(publicGi);
          //   this.g.loadGlobalSetting(detail);
          // }

          
          if (tokenObj) {
            // console.log(`have token tokenObj?`, tokenObj);
            const { profileType } = tokenObj;
            const result = await (
              await this.authAPI.loginViaToken('Bearer ' + tokenObj)
            )
              .toPromise()
              .catch((err) => {
                return Promise.resolve(null);
              });
              console.log('resulttokenObj', result);
            // console.log(`loginviatoken?`, result);
            // check if result is null || token expired
            if (!result) {
              // when token is null
              this.g.gHasToken = true;
              this.g.loadingJwt = false;
              // this.b.clearJws();
              return this.b.navigateRoot("/login");
            }
            const r: any = result;
           await this.b.setJws(tokenObj, r.profile, r.mediaUrl);
           await this.fcm.initPush();
           await  this.b.loadLoading(false);
            this.b.menuOpen();
            this.b.menuOpen();
            console.log("this.g.profile", this.g.profile)
            // console.log("check cartLoaded?", this.g.cartLoaded);
            // console.log(`this.router.url (2)`, this.router.url);
            //
            this.g.loadingJwt = false;
            // if (`/login` === this.router.url) {
            //   console.log(`enter login`);
            //   this.g.loadingJwt = false;
            //   this.b.navigateRoot(`/customer`);
            //   return;
            // } else if (`/login/admin` === this.router.url) {
            //   this.g.loadingJwt = false;
            //   this.b.navigateRoot(`/customer`);
            //   return;
            // }

            if (!this.g.accessCode) {
              // this.gacH.generateAccessCode();
              this.b.loadLoading(false);
            } else {
              this.g.accessCode = this.g.profile.accessCode;
            }
          } else {
            // this.b.toast(
            //   `Oops! Looks like you've been logged out. Please log in again.`,
            //   3000,
            //   "tertiary"
            // );
            this.g.loadingJwt = false;
            this.b.clearJws();
            // this.b.navigateRoot(defaultRoot);
          }
        }
      }
    });
  }
  async generateSSO() {
    (await this.userAPI.generateSSO()).subscribe((result) => {
      const r: any = result;

      if (!r.ok) return;
      this.b.toast(r.detail.ssoToken, 10000);
    });
  }
  async showBearer() {
    this.b.toast(this.g.jws, 10000);
  }

  goToWebsite() {
    this.b.openTab(`https://qzonetech.com`);
  }
  logout() {
    // this.ns.disconnect();
    this.b.toast(`Successfully logged out.`);
    this.b.clearJws();
    this.b.navigateRoot(`/login`);
  }
  profile() {
    this.b.navigateRoot(`/profile`);
  }
  stopCamera() {
    BarcodeScanner.stopScan();
    document.querySelector("#splitPane").classList.remove("scanner-active");
    document.querySelector("#cameraScreen").classList.remove("showDisplay");
    document.querySelector("#cameraScreen").classList.add("hideDisplay");
  }
  async checkVersion() {
    const result2 = await (await this.pubApi.globalSetting())
      .toPromise()
      .catch((err) => {
        return Promise.resolve(null);
      });
    if (result2) {
      this.g.globalSetting = result2.detail;
      // const r2: any = result2;
      // console.log(`globalSetting?`, r2);
      // this.g.posSetting.taxName = r2.detail.taxName;
      // this.g.posSetting.taxRate = r2.detail.taxRate;
      // this.g.posSetting.taxRateInString = `${(
      //   r2.detail.taxRate * 100
      // ).toFixed()}`;
      // this.g.mediaUrl = r2.mediaUrl;
      // // this.g.appLandingSite = r2.detail.appLandingSite;
      // this.g.iosVersion = r2.detail.iosVersion;
      // this.g.androidVersion = r2.detail.androidVersion;
      // this.g.appAnnouncement = r2.detail.appAnnouncement;
      // this.g.toggleAppAnnouncement = r2.detail.toggleAppAnnouncement;
      // this.g.affiliateGroupCodeMessage = r2.detail.affiliateGroupCodeMessage;
      // this.g.affiliateTopupLimit = Number(r2.detail.affiliateTopupLimit);
      // this.g.affiliateGroupRemovalCountdown =
      //   r2.detail.affiliateGroupRemovalCountdown;
      // this.g.topupDisclaimerMessage = r2.detail.topupDisclaimerMessage;
      // this.g.termsAndConditions = r2.detail.termsAndConditions;
      // this.g.pdpa = r2.detail.pdpa;

      if (Capacitor.getPlatform() === "ios") {
        if (this.g.iosVersion !== currentVersion) {
          const alertIOS = await this.alertCtrl.create({
            // cssClass: "",
            header: "A new version is available",
            message: "Do you want to update to the latest version?",
            buttons: [
              {
                text: "Cancel",
                role: "cancel",
                cssClass: "secondary",
                handler: (blah) => {
                  // console.log("Confirm Cancel: blah");
                },
              },
              {
                text: "Update",
                handler: async () => {
                  this.b.openExternalLink(
                    `https://apps.apple.com/us/app/timbre-app/id6443795989`
                  );
                },
              },
            ],
          });
          await alertIOS.present();
        }
      }
      if (Capacitor.getPlatform() === "android") {
        if (this.g.androidVersion !== currentVersion) {
          const alertIOS = await this.alertCtrl.create({
            // cssClass: "",
            header: "A new version is available",
            message: "Do you want to update to the latest version?",
            buttons: [
              {
                text: "Cancel",
                role: "cancel",
                cssClass: "secondary",
                handler: (blah) => {
                  // console.log("Confirm Cancel: blah");
                },
              },
              {
                text: "Update",
                handler: async () => {
                  this.b.openExternalLink(
                    `https://play.google.com/store/apps/details?id=io.qzt.timbre`
                  );
                },
              },
            ],
          });
          await alertIOS.present();
        }
      }
    } else {
    }
  }
}
